{
  "dynamic-survey": {
    "survey_footer": "By submitting you agree to MAJORITY’s <a href=\"{terms_conditions_link}\" class=\"{link_class}\" target=\"_blank\">Terms and Conditions</a>, <a href=\"{privacy_policy_link}\" class=\"{link_class}\" target=\"_blank\">Privacy Policy</a>, and to receive email communication."
  }
}
